'use client'

import React from 'react';

interface AnimatedOrbProps {
  size?: number;
  className?: string;
}

const AnimatedOrb = ({ size = 200, className = "" }: AnimatedOrbProps) => {
  return (
    <div className={`relative ${className}`} style={{ width: size, height: size }}>
      {/* Main fluid blob */}
      <div 
        className="absolute inset-0 rounded-full"
        style={{
          background: `radial-gradient(ellipse 60% 80% at 40% 30%, 
            rgba(221, 248, 195, 0.9) 0%,
            rgba(168, 225, 223, 0.8) 35%,
            rgba(93, 151, 209, 0.9) 70%,
            rgba(93, 151, 209, 0.95) 100%)`,
          filter: 'blur(1px)',
          animation: 'morphBlob 8s ease-in-out infinite',
          boxShadow: `
            0 20px 60px rgba(93, 151, 209, 0.3),
            0 8px 25px rgba(168, 225, 223, 0.2)
          `
        }}
      />
      
      {/* Secondary flowing layer */}
      <div 
        className="absolute rounded-full"
        style={{
          top: '5%',
          left: '5%',
          width: '90%',
          height: '90%',
          background: `radial-gradient(ellipse 80% 60% at 60% 70%, 
            rgba(221, 248, 195, 0.7) 0%,
            rgba(168, 225, 223, 0.5) 40%,
            transparent 80%)`,
          animation: 'morphSecondary 12s ease-in-out infinite reverse',
          filter: 'blur(2px)'
        }}
      />
      
      {/* Inner flowing core */}
      <div 
        className="absolute rounded-full"
        style={{
          top: '20%',
          left: '15%',
          width: '70%',
          height: '65%',
          background: `radial-gradient(ellipse 90% 70% at 30% 40%, 
            rgba(93, 151, 209, 0.8) 0%,
            rgba(168, 225, 223, 0.6) 50%,
            rgba(221, 248, 195, 0.4) 85%,
            transparent 100%)`,
          animation: 'morphCore 10s ease-in-out infinite',
          filter: 'blur(3px)',
          mixBlendMode: 'multiply'
        }}
      />
      
      {/* Highlight blob */}
      <div 
        className="absolute rounded-full"
        style={{
          top: '15%',
          left: '20%',
          width: '40%',
          height: '35%',
          background: `radial-gradient(ellipse 70% 80% at 50% 50%, 
            rgba(255, 255, 255, 0.4) 0%,
            rgba(221, 248, 195, 0.3) 30%,
            transparent 70%)`,
          animation: 'morphHighlight 6s ease-in-out infinite',
          filter: 'blur(4px)'
        }}
      />
    </div>
  );
};

export default AnimatedOrb;
